import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { getTranslatedPlaceholder } from '../../utils';

class SelectInputWrapper extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value
    };
    this.onChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) this.updateValue();
  }

  componentDidMount() {
    this.updateValue();
  }

  updateValue = () => {
    this.setState({
      value: this.props.value
    });
  };

  handleChange(e, data) {
    const { setFieldValue, name, onChangeBeforeStateUpdate, onChange } = this.props;
    setFieldValue(name, data.value);
    onChangeBeforeStateUpdate(e, data.value);
    this.setState({ value: data.value });
    onChange(e, data.value);
  }

  render = () => {
    const { name, placeholder, options, disabled, className, t, label, title, search } = this.props;
    options.forEach(o => (o.text = t(o.text)));

    return (
      <Dropdown
        fluid
        id={name}
        name={name}
        value={this.state.value}
        options={options}
        placeholder={getTranslatedPlaceholder(label, placeholder, t)}
        disabled={disabled}
        onChange={this.onChange}
        className={className}
        search={search}
        selection
        title={title}
      />
    );
  };
}
SelectInputWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
	search: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).isRequired
};

SelectInputWrapper.defaultProps = {
  disabled: false,
  placeholder: '',
  setFieldValue: () => {},
  onChange: () => {},
  onChangeBeforeStateUpdate: () => {},
  search: false
};

export default withTranslation()(SelectInputWrapper);
